import React from 'react'

import GovPersonnel, { GovPersonnelView } from './gov-personnel'
import PersonnelDetailsView from './views'

const PersonnelDetails = ({ record, base_url }) => (
  <PersonnelDetailsView record={record}>
    {record.gov_person_registrations ? (
      <GovPersonnelView
        personnel={record}
        base_url={base_url}
        gov_registrations={record.gov_person_registrations}
      />
    ) : (
      <GovPersonnel personnel={record} base_url={base_url} />
    )}
  </PersonnelDetailsView>
)

export default PersonnelDetails



// WEBPACK FOOTER //
// ./src/personnel/details/container.js